module.exports = __webpack_public_path__ + "static/media/tapir-green.4f96b05b.png";